export const PURCHASE_ITEM_TYPES = {
  CHEST: 'chest',
  FACTION: 'faction',
  SKIN: 'skin',
  UNIT_SKIN: 'unit_skin',
  CRYSTALS_EXCHANGE: 'crystals_exchange',
};
